import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        // Prevent scrolling on the background body when the modal is open
        document.body.style.overflow = 'hidden'
    }

    disconnect() {
        // Restore scrolling when the modal is removed
        document.body.style.overflow = 'auto'
    }

    close(event) {
        if (event) {
            event.preventDefault()
        }

        // Add a quick fade-out effect if you want, or just remove it immediately
        this.element.remove()
    }

    // Optional: Close if the user clicks the dark background overlay
    closeBackground(event) {
        if (event.target === this.element) {
            this.close()
        }
    }
}